import React from "react";
import Subscribe from "./Subscribe";
import {motion} from "framer-motion";

const JoinCommunity = () => {
  return (
    <div id="community" className="section wf-section">
      <div className="content-wrapper">
        <div className="call-to-action-card">
          <div className="content-block">
          <motion.h1 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="heading-xlarge joincomnty">
                Join Our Community
                <br />
                <small className="color-text-gradient">
                  {" "}
                  to get exclusive news on live updates.
                </small>
              </motion.h1>
          </div>
          <div className="social-icons">
            <motion.a 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} href="#" target="_blank" className="w-inline-block">
              <img
                src="images/discord.svg"
                loading="lazy"
                alt="discord"
                className="socialImg"
              />
            </motion.a>
            <motion.a 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} href="#" target="_blank" className="w-inline-block">
              <img
                src="images/telegram.svg"
                loading="lazy"
                alt="telegram"
                className="socialImg"
              />
            </motion.a>
            <motion.a 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} href="#" target="_blank" className="w-inline-block">
              <img
                src="images/twitter-big.svg"
                loading="lazy"
                alt="Twitter"
                className="socialImg"
              />
            </motion.a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinCommunity;
